import { render, staticRenderFns } from "./Batch.vue?vue&type=template&id=4d3cbc6c&"
import script from "./Batch.vue?vue&type=script&lang=js&"
export * from "./Batch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports